export const pedidosInitialState = {
  pedidoLavandaria: [],
};
